import { GetTagesDatenQuery } from '@/gql/graphql';
import { Arbeitszeit } from '@/domain/termine/shared/types/Arbeitszeit';

type ArbeitszeitenQueryResult =
  GetTagesDatenQuery['termine_termineKalenderByStandortIdAndZeitraum'][0]['termine'][0]['termine_arbeitszeiten'];

export function mapArbeitszeiten(
  arbeitszeiten: ArbeitszeitenQueryResult,
): Arbeitszeit[] {
  if (!arbeitszeiten) return [];

  return arbeitszeiten.map((az) => ({
    id: az.id,
    datum: az.datum,
    beginn: az.beginn ?? null,
    ende: az.ende ?? null,
    arbeitsbereich: {
      markierung: az.arbeitsbereich.markierung,
      name: az.arbeitsbereich.name,
    },
    mitarbeiter: {
      vorname: az.mitarbeiter.vorname,
      nachname: az.mitarbeiter.nachname,
      bildUrl: az.mitarbeiter.bildUrl ?? null,
    },
  }));
}
